module.exports = __webpack_public_path__ + "img/icon-hamburger-close.d49dd88b.svg";